// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@vanmeter/Overrides/Widgets/RequestRma/RequestRmaHeader";
import IconPaginationArrowLeft from "@vanmeter/XDL/Icons/IconPaginationArrowLeft";


headerStyles.headerGridContainer = { gap: 16 };

headerStyles.titleGridItem = {
    width: [10, 11, 11, 6, 6],
};

headerStyles.title = {
    variant: "h1",
};

headerStyles.returnLink = { icon: { iconProps: { src: IconPaginationArrowLeft, size: 16 } } }
